import { ReactNode } from 'react';
import { Label } from '../ui/label';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

interface LabelWithInfoProps {
  readonly info: string;
  readonly children: ReactNode;
  readonly htmlFor?: string;
  readonly className?: string;
}

export default function LabelWithInfo({
  info,
  children,
  htmlFor,
  className
}: LabelWithInfoProps): JSX.Element {
  return (
    <div className='flex items-center gap-1.5'>
      <Label htmlFor={htmlFor} className={className}>
        {children}
      </Label>
      <InfoTooltip content={info} />
    </div>
  );
}
